import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { usersService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useInitializeMobilePhoneChangeMutation = ({
	onSuccess,
}: {
	onSuccess: Function;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ mobilePhone }: { mobilePhone: string }) => {
			return usersService.initializeMobilePhoneChange({
				mobile_phone: mobilePhone,
			});
		},
		{
			onSuccess: (_data, { mobilePhone }) => {
				onSuccess?.(mobilePhone);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useInitializeMobilePhoneChangeMutation;
